import React from'react';
import{useLocation,useNavigate}from'react-router-dom';

export default function OwnerEntertainment(){
  const n=useNavigate();
  const location=useLocation();

  const owner=
    location.pathname.startsWith('/owner/');

  const chessPath=
    owner
      ?'/owner/chess'
      :'/chess';

  const onlinePath=
    owner
      ?'/owner/chess/online'
      :'/chess/online';

  const internationalPath=
    owner
      ?'/owner/international-chess'
      :'/international-chess';

  return(
    <div style={S.page}>
      <div style={S.wrap}>
        <button
          onClick={()=>n(owner?'/owner':'/')}
          style={S.back}
        >
          ‹ 返回
        </button>

        <h2 style={S.title}>
          休闲娱乐
        </h2>

        <button
          onClick={()=>n(chessPath)}
          style={S.card}
        >
          <div style={S.icon}>
            帥
          </div>

          <div>
            <b style={S.chineseTitle}>
              中国象棋
            </b>

            <div style={S.desc}>
              人机对战 · 棋力定级 · 同屏双人
            </div>
          </div>
        </button>

        <button
          onClick={()=>n(onlinePath)}
          style={S.card}
        >
          <div style={{
            ...S.icon,
            color:'#6d4c2e'
          }}>
            將
          </div>

          <div>
            <b style={S.onlineTitle}>
              中国象棋联机
            </b>

            <div style={S.desc}>
              小区固定房间 · 在线对弈
            </div>
          </div>
        </button>

        <button
          onClick={()=>n(internationalPath)}
          style={S.card}
        >
          <div style={{
            ...S.icon,
            fontFamily:'serif',
            color:'#2f2f2f'
          }}>
            ♔
          </div>

          <div>
            <b style={S.internationalTitle}>
              国际象棋
            </b>

            <div style={S.desc}>
              标准规则 · 面对面对战
            </div>
          </div>
        </button>

        <div style={S.footer}>
          休闲娱乐 · 文明对弈
        </div>
      </div>
    </div>
  );
}

const S={
  page:{
    minHeight:'100vh',
    background:'#f5f1e8',
    padding:16,
    boxSizing:'border-box'
  },

  wrap:{
    maxWidth:430,
    margin:'0 auto'
  },

  back:{
    border:0,
    background:'none',
    fontSize:16,
    padding:'8px 0'
  },

  title:{
    margin:'8px 0 18px',
    color:'#432c25'
  },

  card:{
    width:'100%',
    padding:18,
    border:0,
    borderRadius:16,
    background:'#fff',
    textAlign:'left',
    boxShadow:'0 4px 14px #0002',
    marginBottom:12,
    display:'flex',
    alignItems:'center',
    gap:15,
    cursor:'pointer'
  },

  icon:{
    width:48,
    height:48,
    flex:'0 0 48px',
    borderRadius:'50%',
    background:'#f5efe6',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontSize:27,
    fontWeight:900,
    color:'#9b2c24'
  },

  chineseTitle:{
    fontSize:20,
    color:'#9b2c24'
  },

  onlineTitle:{
    fontSize:20,
    color:'#6d4c2e'
  },

  internationalTitle:{
    fontSize:20,
    color:'#292929'
  },

  desc:{
    marginTop:6,
    color:'#777',
    fontSize:13
  },

  footer:{
    marginTop:18,
    textAlign:'center',
    fontSize:12,
    color:'#998a7d'
  }
};
